import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function BaseEconomica() {
  const { watch } = useFormContext();
  
  const setoresEconomicos = watch('setores_economicos');
  const mostraOutroSetor = Array.isArray(setoresEconomicos) && setoresEconomicos.includes('outro');
  const mostraStartups = watch('startups_presenca') === 'sim';
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a base econômica do município. Utilize dados oficiais sempre que possível.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="setores_economicos"
          label="Setores econômicos predominantes (máximo 3)"
          type="checkbox"
          options={[
            { value: 'agropecuaria', label: 'Agropecuária' },
            { value: 'industria', label: 'Indústria' },
            { value: 'comercio', label: 'Comércio' },
            { value: 'servicos', label: 'Serviços' },
            { value: 'tecnologia', label: 'Tecnologia' },
            { value: 'energia', label: 'Energia' },
            { value: 'outro', label: 'Outro' },
          ]}
          helpText="Selecione até 3 setores predominantes na economia local"
        />
        
        {mostraOutroSetor && (
          <div className="mt-2">
            <FormField
              name="setores_economicos_outro"
              label="Especifique outro setor econômico"
              placeholder="Descreva o setor econômico"
              helpText="Preencha apenas se selecionou 'Outro' acima"
            />
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="pib_municipal"
          label="PIB Municipal (R$)"
          type="currency"
          placeholder="Digite o valor do PIB municipal"
          helpText="Valor em reais do último PIB municipal divulgado"
        />
        
        <FormField
          name="participacao_pib"
          label="Participação no PIB da RIDE (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem que o município representa no PIB total da RIDE-DF"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>

      <div className="mt-4">
        <FormField
          name="exportacoes_importacoes"
          label="Exportações e importações anuais"
          type="textarea"
          placeholder="Descreva os principais produtos exportados e importados e seus valores aproximados"
          helpText="Informe os principais produtos e valores aproximados"
        />
      </div>
      
      <div className="mt-6">
        <h3 className="text-md font-medium mb-3">Perfil Empresarial</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            name="numero_empresas"
            label="Número total de empresas ativas"
            type="numeric"
            thousandSeparator="."
            decimalSeparator=","
            placeholder="Digite o número total de empresas"
            helpText="Total de empresas formalmente registradas"
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <FormField
            name="microempresas_percentual"
            label="Microempresas (%)"
            type="percent"
            placeholder="Digite a porcentagem"
            helpText="Porcentagem de microempresas"
            validation={{
              min: {
                value: 0,
                message: 'O valor deve ser maior ou igual a 0',
              },
              max: {
                value: 100,
                message: 'O valor deve ser menor ou igual a 100',
              },
            }}
          />
          
          <FormField
            name="pequenas_empresas_percentual"
            label="Pequenas empresas (%)"
            type="percent"
            placeholder="Digite a porcentagem"
            helpText="Porcentagem de pequenas empresas"
            validation={{
              min: {
                value: 0,
                message: 'O valor deve ser maior ou igual a 0',
              },
              max: {
                value: 100,
                message: 'O valor deve ser menor ou igual a 100',
              },
            }}
          />
          
          <FormField
            name="medias_grandes_empresas_percentual"
            label="Médias e grandes empresas (%)"
            type="percent"
            placeholder="Digite a porcentagem"
            helpText="Porcentagem de médias e grandes empresas"
            validation={{
              min: {
                value: 0,
                message: 'O valor deve ser maior ou igual a 0',
              },
              max: {
                value: 100,
                message: 'O valor deve ser menor ou igual a 100',
              },
            }}
          />
        </div>
      </div>
      
      <div className="mt-6">
        <FormField
          name="startups_presenca"
          label="Startups e empresas de base tecnológica"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se existem startups ou empresas de base tecnológica no município"
        />
        
        {mostraStartups && (
          <div className="mt-2">
            <FormField
              name="startups_setores"
              label="Setores de atuação"
              placeholder="Digite os setores de atuação das startups"
              helpText="Principais setores de atuação das startups locais"
            />
          </div>
        )}
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao2"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao2"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
